export const TOOLTIP_COLUMN_COUNTRY_NAME = "country";

export const TOOLTIP_COLUMN_METRIC_NAME = "value";
